var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body card-body-custom"},[_c('b-row',[_c('a',{attrs:{"href":_vm.mData.dataDefault.links,"target":"_blank","rel":"noopener noreferrer"}})])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }